// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const unp: CountryValidator<"BY"> = createValidator(
  "by.unp",
  28,
);

export default unp;
export const compact = unp.compact;
export const format = unp.format;
export const validate = unp.validate;
export const generate = (): string =>
  unp.generate?.() ??
  (() => {
    throw new Error(
      "Validator by.unp cannot generate values",
    );
  })();
